<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <div class="col-4" v-if="isCreate()">
            <div class="text-left">
              <button
                class="btn btn-secondary custom-shadow-btn"
                @click="$router.push('sensors/create')"
              >
                <em class="fa fa-plus"></em>
                {{ $t('devices.add_sensor') }}
              </button>
            </div>
          </div>
          <div class="col-12 text-center">
            <hr />
          </div>
          <el-dialog
            v-if="isShow()"
            :title="nameSensorSelected"
            :visible.sync="modals.read"
            width="70%"
            top="2%"
          >
            <p>
              {{ $t('common_words.selected_record_info') }}
            </p>
            <div class="card" v-if="rowData">
              <div class="card-body" v-if="rowData">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td :style="'background-color: ' + rowData.color">
                        <h6>
                          <strong>{{ $t('common_words.color') }}:</strong>
                        </h6>
                        {{ rowData.color }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.name') }}:</strong>
                        </h6>
                        {{ rowData.name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.description') }}:</strong>
                        </h6>
                        {{ rowData.two_name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.code') }}:</strong>
                        </h6>
                        {{ rowData.code }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('labor.unit') }}:</strong>
                        </h6>
                        {{ rowData.unit }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>¿{{ $t('devices.calculated') }}?:</strong>
                        </h6>
                        {{
                          rowData.calculated === 0
                            ? $t('common_words.mayus_no')
                            : $t('common_words.mayus_yes')
                        }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>¿{{ $t('devices.probe_belongs') }}?:</strong>
                        </h6>
                        {{
                          rowData.is_probe === 0
                            ? $t('common_words.mayus_no')
                            : $t('common_words.mayus_yes')
                        }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.value') }}:</strong>
                        </h6>
                        {{ rowData.field }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{ $t('common_words.geo_position') }}:</strong
                          >
                        </h6>
                        Lat: {{ rowData.latitude }} - Lon:
                        {{ rowData.longitude }}
                        <div class="col-12">
                          <div
                            ref="map"
                            class="map"
                            style="height: 500px"
                          ></div>
                        </div>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{ $t('devices.associated_stations') }}:</strong
                          >
                        </h6>
                        <span
                          v-for="(station, index) in rowData.station_names"
                          :key="index"
                        >
                          <el-tag type="info">{{ station }}</el-tag>
                        </span>
                        <el-tag
                          type="warning"
                          v-if="rowData.station_names.length == 0"
                          >{{ $t('devices.no_associated_stations') }}</el-tag
                        >
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{
                              $t('common_words.associated_companies')
                            }}:</strong
                          >
                        </h6>
                        <span
                          v-for="(business, index) in rowData.business_names"
                          :key="index"
                        >
                          <el-tag type="info">{{ business }}</el-tag>
                        </span>
                        <el-tag
                          type="warning"
                          v-if="rowData.business_names.length == 0"
                          >{{
                            $t('common_words.no_associated_companies')
                          }}</el-tag
                        >
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="custom-margin-h6-table">
                          <strong
                            >{{ $t('common_words.associated_farms') }}:
                          </strong>
                        </h6>
                        <span
                          v-for="(farm, index) in rowData.farm_names"
                          :key="index"
                        >
                          <el-tag type="info">{{ farm }}</el-tag>
                        </span>
                        <el-tag
                          type="warning"
                          v-if="rowData.farm_names.length == 0"
                          >{{ $t('common_words.no_associated_farms') }}</el-tag
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer footer-date-at" v-if="rowData">
                <p class="text-muted">
                  <small
                    >{{ $t('common_words.created_on') }}:
                    {{ rowData.created_at }}</small
                  >
                </p>
              </div>
            </div>
          </el-dialog>
        </div>
        <div v-if="isIndex()">
          <card-header
            :propPagination="pagination"
            @searchedQuery="searchedQuery"
            class="mr-3 mt-3"
          ></card-header>
          <master-table
            :cellStyle="handleCellStyle"
            :columns="tableColumns"
            :infoTable="queriedData"
            :defaultSort="{ prop: 'name', order: 'descending' }"
          >
            <template slot="addColumnsOperations">
              <table-columns-operations
                v-if="isShow() || isUpdate() || isDelete()"
                :minWidth="110"
                @handleDelete="handleDelete"
                @handleEdit="handleEdit"
                @handleView="handleView"
              />
            </template>
          </master-table>
        </div>
        <not-index-permissions v-else />
        <card-footer ref="cardfooter" :propPagination="pagination" />
        <export-tables
          :pdf="{
            filename: `${$t('devices.sensors')}.pdf`,
            route: 'devices/sensors/pdf',
          }"
          :xls="{
            filename: `${$t('devices.sensors')}.xlsx`,
            route: 'devices/sensors/excel',
          }"
        />
        <br />
      </card>
    </div>
  </div>
</template>
<script>
import { Pagination as LPagination } from 'src/components/index';
import SweetAlert from 'src/class/Alerts';
import configTable from './sensorTable';
import { Axios } from 'src/class/Axios.js';
import Fuse from 'fuse.js';
import moment from 'moment';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import mixinMasters from 'src/util/mixinMasters';
import { MixinExport } from 'src/mixins/mixin-export';
import MixinMenu from 'src/util/mixinMenu';
import i18n from 'src/i18n';

export default {
  components: {
    LPagination,
  },

  computed: {
    ...configTable().search,
    nameSensorSelected() {
      return this.$i18n.t('common_words.record_selected_threepoints');
    },
    handleCellStyle: () => {
      return ({ row, columnIndex }) => {
        if (row.color && columnIndex == 7) {
          return 'background-color: ' + row.color;
        }
      };
    },
  },

  data() {
    return {
      center: {
        lat: 10.8906,
        lng: -74.18756,
      },
      sensorForm: {},
      pagination: {},
      tableColumns: [],
      modals: {
        read: false,
      },
      searchQuery: '',
      tableData: [],
      rowData: null,
      fuseSearch: null,
      map: null,
    };
  },

  mixins: [
    MixinPermissions,
    MixinArcgisMap,
    mixinMasters,
    MixinExport,
    MixinMenu,
  ],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    openModal(name) {
      this.modals[name] = true;
    },

    closeModal(name) {
      this.modals[name] = false;
    },

    handleView(_, row) {
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.center.lat = this.rowData.latitude
        ? parseFloat(this.rowData.latitude)
        : this.center.lat;
      this.center.lng = this.rowData.longitude
        ? parseFloat(this.rowData.longitude)
        : this.center.lng;
      this.modals['read'] = true;

      this.loadBaseMap(null);
    },

    handleEdit(_, row) {
      row.url_path_form = '/sensors/edit';
      this.sensorForm = Object.assign({}, row);
      sessionStorage.setItem('editForm', JSON.stringify(this.sensorForm));
      this.$router.push({
        path: 'sensors/edit',
      });
    },

    handleDelete(_, row) {
      this.sensorForm = row;
      SweetAlert.delete(
        `${i18n.t('devices.the_sensor')} ${this.sensorForm.name}`
      ).then((result) => {
        if (result.value) this.deleteSensor();
      });
    },

    deleteSensor() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.sensorForm.route = 'devices/sensors';
        Axios.destroyMaster(this.sensorForm)
          .then((response) => this.modifyTable(2, this.sensorForm.id, response))
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Axios.getMasters('devices/sensors')
        .then((response) => {
          this.tableData = response.data.data;
          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: [
              ...this.tableColumns.map((prop) => {
                return prop.prop;
              }),
              'color',
            ],
          });
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('devices');
  },

  destroyed() {
    this.deselectedItemOnMenu('devices');
  },
};
</script>
<style></style>
